var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    //On editor close, create new endpoints/drop deleted endpoints
    //There should be 1 endpoint that can't be mapped to the filters from our editor
    //This is the default 'fail' endpoint, do not delete it :-)

    FilterBrickModel: function (opts) {
        var block = opts.block
            , editor = opts.editor
            , form = editor.find('form')
            , blockElementId = block.attr('id');
        
        var defaultOutput = _.find(
            Operator.Layout.connectionManager.exportEndpoints(blockElementId)[Operator.ConnectionManager.sourcePortType]
            , {isDefault: true}
        );
        
        Operator.Layout.setupCollections(form);
        
        form.on('submit', function (e) {
            var portElements = editor.find('.filter-container .filter-model input[name$="Name"]');
            var portNames = _.map(_.filter(portElements , function(e){
                return !!e.value 
            } ),'value');
            
            if (portNames.indexOf(defaultOutput.name) !== -1){
                cancelFormSubmitWithError(e, '\'' + defaultOutput.name + '\' is a reserved port name');
                return false;
            }
            
            var result = Operator.Layout.connectionManager.updateEndpointsFromSpecs(blockElementId, {
                input: undefined,
                output: _.concat(defaultOutput.name, portNames)
            });
            
            if (!result.isValid){
                cancelFormSubmitWithError(e, result.errors.join('\n'));
            } 
        });
        
        function cancelFormSubmitWithError(event, error) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            alert(error);
        }
    }
});